export default {
  site: {
    brandKo: "한국고무공업주식회사",
    brandShort: "한국고무공업",
    brandEn: "HANKUK RUBBER TECH. CO.,LTD.",
    tel: "031-434-0341",
    telLink: "tel:031-434-0341",
    email: "hkrubbert@naver.com",
    emailLink: "mailto:hkrubbert@naver.com",
    fax: "031-434-0340",
    address: "경기도 시흥시 옥구천서로 237번길 36",
    established: 1975,
    experienceYears: 50,
  },
  nav: {
    links: [
      { label: "HOME", to: "/" },
      {
        label: "회사소개",
        to: "/about/overview",
        sub: [
          { label: "CEO 인사말", to: "/about/ceo" },
          { label: "회사개요", to: "/about/overview" },
          { label: "회사연혁", to: "/about/history" },
          { label: "인증현황", to: "/about/certifications" },
          { label: "찾아오는 길", to: "/about/location" },
        ],
      },
      { label: "사업소개", to: "/business" },
      { label: "제품소개", to: "/products" },
      { label: "기술자료", to: "/technical" },
      { label: "고객지원", to: "/support" },
      { label: "견적요청", to: "/quotation" },
      { label: "문의하기", to: "/contact" },
    ],
    quoteRequest: "견적 요청",
    quoteRequestFull: "견적 요청하기",
    menuOpen: "메뉴 열기",
  },
  topbar: {
    tagline: "HANKUK RUBBER TECH · 산업용 고무제품 전문 제조",
    tel: "TEL · 031-434-0341",
  },
  footer: {
    desc: "한국고무공업주식회사는 다양한 산업 분야의 고무제품을 개발·생산하며, 고객이 겪는 문제를 함께 해결하는 기술 중심 제조기업입니다.",
    sitemapTitle: "SITEMAP",
    contactTitle: "CONTACT",
    links: [
      {
        label: "회사소개",
        to: "/about/overview",
        sub: [
          { label: "CEO 인사말", to: "/about/ceo" },
          { label: "회사개요", to: "/about/overview" },
          { label: "회사연혁", to: "/about/history" },
          { label: "인증현황", to: "/about/certifications" },
          { label: "찾아오는 길", to: "/about/location" },
        ],
      },
      { label: "사업소개", to: "/business" },
      { label: "제품소개", to: "/products" },
      { label: "기술자료", to: "/technical" },
      { label: "고객지원", to: "/support" },
      { label: "견적요청", to: "/quotation" },
      { label: "문의하기", to: "/contact" },
    ],
    address: "주소",
    tel: "TEL",
    fax: "FAX",
    privacy: "개인정보처리방침",
    terms: "이용약관",
    sitemap: "사이트맵",
    admin: "관리자",
    rights: "All rights reserved.",
  },
  comingSoon: {
    cards: {
      precision: { title: "정밀 설계", desc: "도면 분석 및 시제품 설계" },
      molding: { title: "압축성형 양산", desc: "안정적인 품질의 대량 생산" },
      quality: { title: "품질 보증", desc: "전수 검사 및 사후 지원" },
    },
    backHome: "메인으로 돌아가기",
    contactNow: "지금 문의하기",
  },
  notFound: {
    title: "이 페이지는 아직 생성되지 않았습니다",
    hint: "이 페이지에 대해 더 알려주시면 만들어 드릴게요",
  },
};